/**
 * Get current ISO timestamp
 */
export function now() {
    return new Date().toISOString();
}
/**
 * Parse a date string to ISO format
 */
export function toISO(date) {
    if (date instanceof Date) {
        return date.toISOString();
    }
    return new Date(date).toISOString();
}
/**
 * Get relative time string (e.g., "2 hours ago")
 */
export function relativeTime(date) {
    const now = Date.now();
    const then = new Date(date).getTime();
    const diff = now - then;
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    if (days > 0)
        return `${days}d ago`;
    if (hours > 0)
        return `${hours}h ago`;
    if (minutes > 0)
        return `${minutes}m ago`;
    return 'just now';
}
//# sourceMappingURL=datetime.js.map